import { render, staticRenderFns } from "./PDFThumbnail.vue?vue&type=template&id=acb77a06&scoped=true"
import script from "./PDFThumbnail.vue?vue&type=script&lang=ts"
export * from "./PDFThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./PDFThumbnail.vue?vue&type=style&index=0&id=acb77a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb77a06",
  null
  
)

export default component.exports